<template>
  <div class="vouchers__exchange">
    <div v-if="isLoading">
      <half-circle-spinner
        :animation-duration="1500"
        :size="50"
        color="#1D3354"
        class="mx-auto"
      />
    </div>
    <div v-else>
      <p class="vouchers__exchange--title mb-3 pl-1">
        Select voucher to redeem :</p>
      <div class="d-flex m-0 vouchers__exchange--show overflow-x-auto">
        <!-- e - voucer-->
        <div class="col-md-3 pb-0 px-1">
          <img @click.prevent="opendetail('e-2juta')"
             src="@/assets/image/image/Shipmet Disc Voucher 2jt.png">
        </div>
        <div class="col-md-3 pb-0 px-1">
          <img @click.prevent="opendetail('e-600')"
             src="@/assets/image/image/Shipmet Disc Voucher 600 Ribu.png">
        </div>
        <div class="col-md-3 pb-0 px-1">
          <img @click.prevent="opendetail('e-200')"
             src="@/assets/image/image/Shipmet Disc Voucher 200 Ribu.png">
        </div>

        <!-- default voucher -->
        <div class="col-md-3 pb-0 px-1">
          <img @click.prevent="opendetail('5')"
              src="@/assets/image/image/ap-voucher-100.png">
        </div>
        <div class="col-md-3 pb-0 px-1">
          <img @click.prevent="opendetail('6')"
              src="@/assets/image/image/ap-voucher-300.png">
        </div>
        <div class="col-md-3 pb-0 px-1">
          <img @click.prevent="opendetail('7')"
              src="@/assets/image/image/ap-voucher-1000.png">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners'
export default {
  props: {
    andalinPoint: String,
    isLoading: Boolean
  },
  components: {
    HalfCircleSpinner
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
    opendetail (type) {
      if (this.andalinPoint) {
        const point = this.andalinPoint
        if (type === '5') {
          const payload = {
            name: `vouncher-${type}`,
            group: 'voucher',
            currentPoint: parseInt(point),
            voucherIDRtext: 'IDR 1,000,000',
            voucherIDRvalue: '1000000',
            redeemPoint: '14200'
          }
          this.$eventHub.$emit('dialog-voucher-img', payload)
        } else if (type === '6') {
          const payload = {
            name: `vouncher-${type}`,
            group: 'voucher',
            currentPoint: parseInt(point),
            voucherIDRtext: 'IDR 300,000',
            voucherIDRvalue: '300000',
            redeemPoint: '3600'
          }
          this.$eventHub.$emit('dialog-voucher-img', payload)
        } else if (type === '7') {
          const payload = {
            name: `vouncher-${type}`,
            group: 'voucher',
            currentPoint: parseInt(point),
            voucherIDRtext: 'IDR 100,000',
            voucherIDRvalue: '100000',
            redeemPoint: '1600'
          }
          this.$eventHub.$emit('dialog-voucher-img', payload)
        } else if (type === 'e-2juta') {
          const payload = {
            name: `${type}`,
            group: 'e-voucer',
            currentPoint: parseInt(point),
            voucherIDRtext: 'IDR 2,000,000',
            voucherIDRvalue: '2000000',
            redeemPoint: '14200'
          }
          this.$eventHub.$emit('dialog-voucher-img', payload)
        } else if (type === 'e-600') {
          const payload = {
            name: `${type}`,
            group: 'e-voucer',
            currentPoint: parseInt(point),
            voucherIDRtext: 'IDR 600,000',
            voucherIDRvalue: '600000',
            redeemPoint: '3600'
          }
          this.$eventHub.$emit('dialog-voucher-img', payload)
        } else if (type === 'e-200') {
          const payload = {
            name: `${type}`,
            group: 'e-voucer',
            currentPoint: parseInt(point),
            voucherIDRtext: 'IDR 200,000',
            voucherIDRvalue: '200000',
            redeemPoint: '1800'
          }
          this.$eventHub.$emit('dialog-voucher-img', payload)
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/andalinpoint/points/Exchange.vue